<p-panel>
    <div class="container-fluid gap-5">
        <div class="row">
            <div class="col" [class.hide-cantidad-maceta]="!showCantidadMaceta">
                <app-reactive-form-builder
                    #builderRef
                    (formChanges)="formChanges($event[0], $event[1])"
                    (goBack)="goBack()"
                    [form]="form.formFields"
                    [serverUrl]="form.env.serverUrl"
                    [dropdownLoadTrigger]="dropdownLoadTrigger"
                    [id]="(getModel().id)?.toString() ?? ''"
                    [dropdownsFinalized]="dropdownsFinalized"
                    [request]="this.getType() === 1 ? this.trazabilidadApi.trazabilidad.PUT : this.trazabilidadApi.trazabilidad.POST"
                    [getRequest]="this.trazabilidadApi.trazabilidad.GET">
                </app-reactive-form-builder>
            </div>
        </div>
    </div>
</p-panel>